export const readCatalogBootstrap = () => {
  if (typeof document === 'undefined') return [];
  try {
    const data = JSON.parse(document.getElementById('ych-catalog-data')?.textContent || '[]');
    return Array.isArray(data) ? data.filter((product) => product && product.id !== 7 && typeof product.name === 'string') : [];
  } catch {
    return [];
  }
};
